//#region Libraries
import {
    useEffect,
    useState 
} from "react";
//#endregion
//#region Styles
import {
    Container, Content, 
    Header, 
    HelperSection 
} from "./styles";
//#endregion
//#region Images
import searchIconFound from "img/search_icon_found.svg";
import searchIconNotFound from "img/search_icon_not_found.svg";
import ErrorIcon from "icons/ErrorIcon";
//#endregion
//#endregion
//#region Components
import DialogAlert from "components/DialogAlert/DialogAlert";
import CloseButton from "components/CloseButton/CloseButton";
import CustomSearchInput from "components/CustomSearchInput/CustomSearchInput";
//#endregion

const SearchDialogAlert = ({
    title, notFoundTitle,
    placeholder,  
    show, toggleShow, 
    changeSearchField, data, 
    minLength, maxLength,
    getDataItemText,
    fillData, loadingSearch = true, 
    clearData, mostSimilar = null,
    notFoundMessage, notFoundSubmessage,
    styles = {}
}) => {
    //#region States
    const [foundItemText, setFoundItemText] = useState("");
    //#endregion
    useEffect(() => {
        if (show) return;
        setFoundItemText("");
        clearData();
    }, [show]);
    //#region Functions
    const getIfFoundItemTextHasMinLength = (value = foundItemText) => {
        if (!minLength) 
            return true;
        return value.length >= minLength;
    }
    const handlerItemSearched = value => {
        setFoundItemText(value);
        const hasMinLength = getIfFoundItemTextHasMinLength(value);
        if (!hasMinLength) {
            clearData();
            return;
        }
        fillData(value);
    };
    const selectDataItem = value => {
        changeSearchField(value);
        toggleShow(false);
    }
    //#endregion
    const anyData = foundItemText && data.length === 0;
    return (
        <DialogAlert 
            show={show} 
            toggleShow={toggleShow}>
            <CloseButton onClick={() => toggleShow(false)}/>
            <Container {...styles}>
                {(getIfFoundItemTextHasMinLength() && anyData && !loadingSearch) 
                ? (
                    <Header>
                        <img src={searchIconNotFound} 
                            alt="Encontrado UTP"
                            data-role="header-icon"/>
                        <h2>
                            {notFoundTitle || "¡Lo sentimos!"}
                        </h2>
                    </Header>
                )
                : (
                    <Header>
                        <img src={searchIconFound} 
                            alt="No encontrado UTP"
                            data-role="header-icon"/>
                        <h2>{title}</h2>
                    </Header>
                )}
                <Content>
                    <CustomSearchInput 
                        dataFound={data}
                        getText={getDataItemText}
                        foundItemText={foundItemText}
                        selectDataItem={selectDataItem}
                        maxLength={maxLength}
                        handlerItemSearched={handlerItemSearched}
                        show={show}
                        placeholder={placeholder}/>
                    {(mostSimilar !== null && anyData && !loadingSearch) && 
                        <HelperSection>
                            <div data-role="main">
                                <ErrorIcon/>
                                <h5>
                                    {notFoundMessage}
                                </h5>
                            </div>
                            {mostSimilar.length > 0 
                            ? <h4>
                                Quizás quisiste decir: <strong>{mostSimilar}</strong>
                            </h4>
                            : <h4>No existe ninguna coincidencia</h4>}
                            {notFoundSubmessage && <h6>{notFoundSubmessage}</h6>}
                        </HelperSection>
                    }
                </Content>
            </Container>
        </DialogAlert>
    );
}

export default SearchDialogAlert;